import HttpService from './baseHttp'

// 事物处理计划
export const HttpWorkDetailList = (data) => HttpService.get('/api/v2/ServiceWorkOrderPlan/findByPageClient', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 查看，创建，编辑，保存并提交，完成，审核
export const HttpGetWorkDetailOne = (data) => HttpService.get('/api/v2/ServiceWorkOrderPlan/detail', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpCreateWorkDetailOne = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/create', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpUpdateWorkDetailOne = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/update', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpsaveAndSubmitWorkDetailOne = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/saveAndSubmit', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpWorkDetailListComplete = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/complete', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpWorkDetailListCheck = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/check', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 导入 导出
export const HttpImportWorkDetail = (data, config) => HttpService.post('/api/v2/ServiceWorkOrderPlan/importProcessedTransactionItems', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });


// 列表 提交，取消
export const HttpWorkDetailListSubmit = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/submit', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpWorkDetailListCancel = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据单据类型和单据号获得项目和仓库
export const HttpGetLineAndWarehouse = (data) => HttpService.get('/api/v2/ServiceWorkOrderPlan/getInfoByOrderTypeAndOrderNo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });



// 删除附件
export const HttpDeleteAttach = (data) => HttpService.post('/api/v1/BizAttach/batchDel', data, {params: {contextId:data.contextId}, baseURL: process.env.VUE_APP_APIURL_UC });
// 事物处理计划管理

export const HttpWorkManageList = (data) => HttpService.get('/api/v2/ServiceWorkOrderPlan/findByPageManager', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓库重推
export const HttpRepushWarehouse = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/repushToWarehouse', data,{ baseURL: process.env.VUE_APP_APIURL_FBB });
//重推附件
export const HttpAttachRepushWarehouse = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/repushAttachToWarehouse', data,{ baseURL: process.env.VUE_APP_APIURL_FBB });


// 根据附件模块和单号查询附件详情
export const HttpGetExcelDetail = (data) => HttpService.get('/api/v1/BizAttach/findByFilters', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });



// 事务执行单-列表页
export const HttpWorkOrderList = (data) => HttpService.get('/api/v2/ServiceWorkOrder/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-创建
// export const HttpAddWorkOrder = (data) => HttpService.post('/api/v2/ServiceWorkOrder/create', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-更新
export const HttpSaveWorkOrder = (data) => HttpService.post('/api/v2/ServiceWorkOrder/save', data, {baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-详情
export const HttpWorkOrder = (data) => HttpService.get('/api/v2/ServiceWorkOrder/detail', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 事务执行单-事务项下拉列表
export const HttpWorkOrderOptionsList = (data) => HttpService.get('/api/v2/ServiceWorkOrder/transactionOptions/', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-获取事务项关联的sku
export const HttpWorkOrderSkuList = (data) => HttpService.get('/api/v2/product/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-保存事务明细
export const HttpSaveWorkOrderItem = (data) => HttpService.post('/api/v2/ServiceWorkOrder/saveTransactionItems', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-保存并确认
export const HttpConfirmAndSaveWorkOrder = (data) => HttpService.post('/api/v2/ServiceWorkOrder/saveAndConfirm', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-取消
export const HttpConfirmWorkOrder = (data) => HttpService.post('/api/v2/ServiceWorkOrder/confirm', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-取消
export const HttpCancelWorkOrder = (data) => HttpService.post('/api/v2/ServiceWorkOrder/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-导入
export const HttpImportWorkOrder = (data, config) => HttpService.post('/api/v2/ServiceWorkOrder/importWorkOrders', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-导出
export const HttpExportWorkOrder = (data, config) => HttpService.get('/api/v2/ServiceWorkOrder/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务项列表 下拉
export const HttpWorkOrderSearchList = (data) => HttpService.get('/api/v2/processedTransaction/findByClientOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//事务项列表
export const HttpWorkOrderItems = (data) => HttpService.get('/api/v2/serviceWorkOrderItem/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-批量确认
export const HttpBatchConfirmWorkOrder = (data) => HttpService.post('/api/v2/ServiceWorkOrder/batchConfirm', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// // 事务执行单-保存事务明细
// export const HttpSaveWorkOrderItem = (data) => HttpService.post('/api/v2/ServiceWorkOrder/saveTransactionItems',data, {  baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-根据单据类型和单号获得相关信息
export const HttpWorkOrderInfo = (data) => HttpService.get('/api/v2/ServiceWorkOrder/getInfoByOrderTypeAndOrderNo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//事务项列表

// 事务执行单-删除明细
export const HttpDelWorkOrderItems = (data) => HttpService.post('/api/v2/ServiceWorkOrder/deleteItems', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-清空明细
export const HttpClearWorkOrderItems = (data) => HttpService.post('/api/v2/ServiceWorkOrder/clearItems', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 事务执行单-添加明细
export const HttpAddWorkOrderItems = (data) => HttpService.post('/api/v2/serviceWorkOrderItem/save', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpFindWorkType = (data) => HttpService.post('/api/v2/processedTransaction/findByOrgWarehouseId', data, { baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpGetWorkorderSpan = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/getCountByStatus', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 异常重处理
export const HttpReprocessError = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/errorReprocess', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 忽略异常
export const HttpIgnoreError = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/ignoreError', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//撤销审核
export const HttpWorkRevokeAudit = (data) => HttpService.post('/api/v2/ServiceWorkOrderPlan/revokeAudit', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
